import { GateOutMismatchMode, TemperatureUnit, TerminalType, UnLocationCodeDto } from '@admin/app/api'

export interface TenantFormProfile {
  id?: number
  name: string
  timezone: string
  culture?: string
  address?: string | null
  temperatureUnit?: TemperatureUnit
  truckArrivalWindowDuration?: number | null
  isInlandJobCreationFlow?: boolean
  hasAutoGeneratedCraneSplit?: boolean
  skipCraneSplit?: boolean
  skipVesselTally?: boolean
  skipRailTally?: boolean
  skipRailTallyLoadPreparation?: boolean
  skipGateOut?: boolean
  skipTruckAppointment?: boolean
  skipVesselVisitReadyForOperation?: boolean
  skipReleaseOrder?: boolean
  skipYardPlanning?: boolean
  skipBerthTimestamp?: boolean
  bayRowUniqueIdentificationMode?: boolean
  showUnifiedOperatorPage?: boolean
  hasGeneralCargo?: boolean
  hasDamageCatalogue?: boolean
  operatorViewConfigs?: TerminalType
  unloCodes?: UnLocationCodeDto[]
  reeferContainerMaxUnpluggedTime?: number | null
  allowGateInWhenUnitNotOnTerminal?: boolean
  allowDirectDelivery?: boolean
  allowOperatorToSelectRailcar?: boolean
  autoTriggerVesselWorkQueues?: boolean
  skipGangSelection?: boolean
  gateOutMismatchMode?: GateOutMismatchMode
  allocationRuleWarningThreshold?: number | null
  blockWarningThreshold?: number | null
  yardWarningThreshold?: number | null
  yardMapAnchorLatitude?: number | null
  yardMapAnchorLongitude?: number | null
  yardMapNorthRotationDegrees?: number | null
}

export const defaultValues: TenantFormProfile = {
  name: '',
  timezone: '',
  culture: '',
  address: '',
  temperatureUnit: TemperatureUnit.Celsius,
  truckArrivalWindowDuration: null,
  isInlandJobCreationFlow: false,
  hasAutoGeneratedCraneSplit: false,
  skipCraneSplit: false,
  skipVesselTally: false,
  skipRailTally: false,
  skipRailTallyLoadPreparation: false,
  skipGateOut: false,
  skipTruckAppointment: false,
  skipVesselVisitReadyForOperation: false,
  skipReleaseOrder: false,
  skipYardPlanning: false,
  skipBerthTimestamp: false,
  bayRowUniqueIdentificationMode: false,
  showUnifiedOperatorPage: false,
  hasGeneralCargo: false,
  hasDamageCatalogue: false,
  operatorViewConfigs: TerminalType.Hig,
  unloCodes: [],
  reeferContainerMaxUnpluggedTime: undefined,
  allowGateInWhenUnitNotOnTerminal: false,
  allowDirectDelivery: false,
  allowOperatorToSelectRailcar: false,
  autoTriggerVesselWorkQueues: false,
  skipGangSelection: false,
  gateOutMismatchMode: GateOutMismatchMode.Warn,
  allocationRuleWarningThreshold: null,
  blockWarningThreshold: null,
  yardWarningThreshold: null,
}
